export enum DATE_TIME_FORMAT {
  DATE_ONLY = "YYYY-MM-DD",
  DATE_FR = "DD-MM-YYYY",
  DATE_MONTH_FR = "MMMM YYYY",
  DATE_FRENCH = "DD-MMMM-YYYY",
}
